import React, {
	createContext,
	useState,
	useContext,
	useCallback,
	useEffect,
} from 'react'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import ModalConfirm from 'src/components/Modal/ModalConfirm'
import ModalOption from 'src/components/Modal/ModalOption'

const ModalContext = createContext({
	// eslint-disable-next-line no-empty-pattern
	openModal: ({}) => {},
	openError: (_error) => {},
	closeModal: () => {},
})
export const ModalProvider = ({ children }) => {
	const [open, setOpen] = useState() as any

	const getErrorMessage = useCallback((error: any) => {
		if (!error) return 'Something went wrong'
		return (
			error?.response?.data?.message ||
			error?.response?.data?.error ||
			error?.message ||
			'Something went wrong'
		)
	}, [])

	const openModal = useCallback(({ type = 'confirm', ...others }) => {
		if (type === 'success') {
			toast.success(others?.label || 'Success')
			return
		}

		if (type === 'error') {
			const errorMessage = others?.error
				? getErrorMessage(others.error)
				: others?.label || 'Something went wrong'
			toast.error(errorMessage)
			return
		}

		if (type === 'warning') {
			toast.warning(others?.label || 'Warning')
			return
		}

		setOpen({ type, ...others })
	}, [getErrorMessage])
	const openError = useCallback((error) => {
		toast.error(getErrorMessage(error))
	}, [getErrorMessage])
	const closeModal = useCallback(() => {
		setOpen('')
	}, [])
	const location = useLocation()

	useEffect(() => {
		closeModal()
	}, [location.pathname, closeModal])
	return (
		<ModalContext.Provider
			value={{
				openModal,
				closeModal,
				openError,
			}}
		>
			{children}
			{open?.type === 'confirm' && (
				<ModalConfirm open={true} handleClose={closeModal} {...open} />
			)}
			{open?.type === 'option' && (
				<ModalOption open={true} handleClose={closeModal} {...open} />
			)}
		</ModalContext.Provider>
	)
}

export const useModal = () => useContext(ModalContext)
